module.exports = __webpack_public_path__ + "static/media/4.2.f418b2ff.png";